import React from 'react';
import { useApi } from '../api/endpoints';
import App from '../App';

const AppWrapper: React.FC = () => {
  const apiClient = useApi();
  return <App apiClient={apiClient} />;
};

export default AppWrapper;
